package com.arena_web.pages

import androidx.compose.runtime.Composable
import com.arena_web.ui.layouts.PageLayout
import com.arena_web.ui.sections.info.InfoBullet
import com.arena_web.ui.sections.info.InfoPageScaffold
import com.arena_web.ui.sections.info.InfoParagraph
import com.arena_web.ui.sections.info.InfoSection
import com.varabyte.kobweb.core.Page

@Page("/delete-account")
@Composable
fun DeleteAccountPage() {
    PageLayout(
        title = "Delete your account",
        description = "How to request deletion of your Arena Pro Play account and associated data.",
        mobileReady = true,
    ) {
        InfoPageScaffold(title = "Delete your Arena Pro Play account") {
            InfoSection("1. About this page") {
                InfoParagraph(
                    "This page explains how to request deletion of your account and associated data on Arena Pro " +
                        "Play, the sports matchmaking service available at arenaproplay.com and in the Arena Pro Play " +
                        "mobile app. It also describes exactly which data is deleted, which data is kept, and for how " +
                        "long."
                )
            }
            InfoSection("2. Delete your account from the app (recommended)") {
                InfoParagraph(
                    "You can delete your account yourself at any time, directly from the Arena Pro Play app or " +
                        "website:"
                )
                InfoBullet("Sign in to your Arena Pro Play account.")
                InfoBullet("Open the profile menu by tapping your avatar in the top bar.")
                InfoBullet("Select \"Delete account\".")
                InfoBullet("Confirm in the dialog that appears. Your account is then deleted immediately.")
            }
            InfoSection("3. Request deletion by email") {
                InfoParagraph(
                    "If you cannot access the app, you can request deletion by writing to inowioss@gmail.com from the " +
                        "email address associated with your Arena account. Please include the subject \"Delete my " +
                        "account\" so we can identify and verify your request. We complete verified requests within 30 " +
                        "days."
                )
            }
            InfoSection("4. What data is deleted") {
                InfoParagraph("When your account is deleted, the following data is permanently removed:")
                InfoBullet("Your posts, and all likes and comments attached to them.")
                InfoBullet("Your stories, and all views and likes attached to them.")
                InfoBullet("Photos and media you uploaded, including your profile and player-card avatars.")
                InfoBullet(
                    "Your personal identifiers — your full name, username and email address are erased from your " +
                        "profile so you can no longer be identified by them."
                )
                InfoBullet(
                    "Your saved payment tokens are removed and any active subscription is cancelled so you are not " +
                        "billed again."
                )
            }
            InfoSection("5. What data is kept, and why") {
                InfoParagraph(
                    "To preserve the integrity of shared content and match history for other players, a limited amount " +
                        "of data is retained after deletion, no longer linked to your identity:"
                )
                InfoBullet(
                    "Chat messages you sent in group and event conversations remain visible to other participants, " +
                        "shown as coming from \"Deleted Account\"."
                )
                InfoBullet(
                    "Historical match results, ratings and leaderboard records are kept in anonymized form so past " +
                        "games and standings stay accurate."
                )
                InfoParagraph(
                    "This retained data no longer contains your name, username or email and cannot be used to " +
                        "contact or identify you."
                )
            }
            InfoSection("6. Retention period") {
                InfoParagraph(
                    "Your personal data is removed from our active systems immediately when the account is deleted. " +
                        "Residual copies in encrypted backups are purged automatically within 90 days. We may retain " +
                        "the minimum records required to comply with legal, tax or fraud-prevention obligations for as " +
                        "long as the law requires."
                )
            }
            InfoSection("7. Contact") {
                InfoParagraph(
                    "For any questions about deleting your account or data, contact us at inowioss@gmail.com or " +
                        "through the Support link in the footer."
                )
            }
        }
    }
}
